import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import { useCart } from "../context/CartContext";
import Logo from '../assets/sanjivni ayurveda logo.png'
import { TbLogin2 } from "react-icons/tb";

const CartIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
  </svg>
);

const MenuIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="3" y1="6" x2="21" y2="6" /><line x1="3" y1="12" x2="21" y2="12" /><line x1="3" y1="18" x2="21" y2="18" />
  </svg>
);

const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
  </svg>
);

const navLinks = [
  { to: "/", label: "Home" },
  { to: "/products", label: "Products" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export default function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { itemCount } = useCart();
  const [user, setUser] = useState(null);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const userData = localStorage.getItem("user");

    if (userData && userData !== "undefined") {
      try {
        setUser(JSON.parse(userData));
      } catch (err) {
        console.error("Invalid JSON:", err);
        setUser(null);
      }
    } else {
      setUser(null);
    }
  }, []);

  const handleLogout = () => {
    localStorage.removeItem("user");
    setUser(null);
  };

  const getLinkClass = ({ isActive }) =>
    isActive ? "nav-link nav-link--active" : "nav-link";

  return (
    <header className={`navbar${scrolled ? " navbar--scrolled" : ""}`}>
      <div className="navbar__inner">
        {/* Logo */}
        <NavLink to="/" className="navbar__logo" onClick={() => setMenuOpen(false)}>
          <img src={Logo} alt="Logo image" width="80px" />
          <div className="logo-text">
            <div className="navbar__logo-text">
              Sanjivani<em>Ayurveda</em>
            </div>
            <div className="navbar__logo-slogun">
              <em>सर्वे सन्तु निरामयाः</em> सर्वे भवन्तु सुखिनः
            </div>
          </div>
        </NavLink>

        {/* Desktop links */}
        <nav className="navbar__links">
          {navLinks.map(({ to, label }) => (
            <NavLink key={to} to={to} className={getLinkClass} end={to === "/"}>
              {label}
            </NavLink>
          ))}
        </nav>

        {/* Cart + Hamburger */}
        <div className="navbar__actions">
          {/* <button className=""> */}
          {/* {user ? (
            <button className="navbar__cart login-btn" onClick={handleLogout}>
              Logout
            </button>
          ) : (
            <NavLink to="/login" className="navbar__cart login-btn">
              <TbLogin2 />
            </NavLink>
          )} */}


          {user ? (
            <NavLink to="/profile" className="navbar__cart login-btn">
              👤
            </NavLink>
          ) : (
            <NavLink to="/login" className="navbar__cart login-btn">
              <TbLogin2 />
            </NavLink>
          )}

          {/* </button> */}
          <NavLink to="/cart" className="navbar__cart" aria-label="Cart">
            <CartIcon />
            <div>{itemCount > 0 && (
              <span className="navbar__cart-badge">{itemCount}</span>
            )}</div>
          </NavLink>
          <button
            className="navbar__hamburger"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {menuOpen ? <CloseIcon /> : <MenuIcon />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`navbar__mobile${menuOpen ? " navbar__mobile--open" : ""}`}>
        {navLinks.map(({ to, label }) => (
          <NavLink
            key={to}
            to={to}
            className={getLinkClass}
            end={to === "/"}
            onClick={() => setMenuOpen(false)}
          >
            {label}
          </NavLink>
        ))}

        <NavLink to="/cart" className="nav-link" onClick={() => setMenuOpen(false)}>
          Cart
        </NavLink>

        {user ? (
          <NavLink to="/profile" className="nav-link" onClick={() => setMenuOpen(false)}>
            Profile
          </NavLink>
        ) : (
          <NavLink to="/login" className="nav-link" onClick={() => setMenuOpen(false)}>
            Login
          </NavLink>
        )}
      </div>
    </header>
  );
}
